import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSmartModalService } from '@bssh/comp-lib';
import { BaseModalComponent, ModalComponentType } from '../base-modal/base-modal.component';
import { IAlertModalInput, IAlertModalOutput } from '../model/action-modal';
import { IAlertModalText } from '../alert-modal/alert-modal-texts';
import { RadBaseModalComponent } from '../rad-base-modal/rad-base-modal.component';

@Component({
  selector: 'app-rad-alert-modal',
  templateUrl: './rad-alert-modal.component.html',
  styleUrls: ['./rad-alert-modal.component.scss'],
})
export class RadAlertModalComponent extends BaseModalComponent implements OnInit, AfterViewInit, OnDestroy {
  modalComponentType = ModalComponentType.RAD;
  modalType = 'radAlertModal';
  modalText: IAlertModalText = {
    title: 'Generic Warning Modal',
    content: 'Pass alert type via modalInput',
    confirmButtonText: 'Proceed',
    closeButtonText: 'Dismiss Warning'
  };
  isProceed = false;
  showCloseButton = true;
  showConfirmButton = true;

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
  ) {
    super(ngxSmartModalService);
  }

  ngOnInit() {
    this.subs.sink = this.data.subscribe((modalInput: IAlertModalInput) => {
      if (modalInput && modalInput.type) {
        if (modalInput.type === 'CUSTOM') {
          this.modalText = modalInput.alertModalText;
          this.showCloseButton = typeof modalInput.showCloseButton === 'boolean' ? modalInput.showCloseButton : this.showCloseButton;
          this.showConfirmButton = typeof modalInput.showConfirmButton === 'boolean' ? modalInput.showConfirmButton : this.showConfirmButton;
        }
      }
    });
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  close(modal: RadBaseModalComponent) {
    const modalOutput: IAlertModalOutput = { isProceed: this.isProceed };
    this.confirm.emit(modalOutput);
    this.confirm.complete();
  }

  accept(modal: RadBaseModalComponent) {
    this.isProceed = true;
    modal.close();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
